import { URLS } from '../../../constants';
import apiClient from '../../client';

const notesApi = {
  note: ({ profileUserId, profileOrgId }: { profileUserId: any; profileOrgId: any }) =>
    apiClient.post(URLS.notes, {
      data: {
        profileUserId,
        profileOrgId,
      },
    }),
  emptyNotes: ({ profileUserId, profileOrgId }: { profileUserId: any; profileOrgId: any }) =>
    apiClient.post(URLS.emptyNotes, {
      data: {
        profileUserId,
        profileOrgId,
      },
    }),
};

export default notesApi;
